/** Claims úteis do JWT de acesso (sem validar assinatura — só fallback de UI). */
export function getAccessTokenClaims() {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return null;
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isKnownRole(role) {
  return role === 'client' || role === 'videomaker' || role === 'admin';
}

/**
 * Garante id/role/email no objeto de usuário da sessão web.
 * Evita estado “logado” sem role após /users/me ou cache parcial.
 */
export function normalizeSessionUser(apiUser, previousUser = null) {
  const prev =
    previousUser && typeof previousUser === 'object'
      ? previousUser
      : readStoredAuthUserRaw() || {};
  const incoming = apiUser && typeof apiUser === 'object' ? apiUser : {};
  const claims = getAccessTokenClaims() || {};

  const id = incoming.id || incoming._id || prev.id || prev._id || claims.sub || null;
  const role = incoming.role || prev.role || claims.role || null;
  const email = incoming.email || prev.email || claims.email || '';

  return {
    ...prev,
    ...incoming,
    ...(id ? { id } : {}),
    ...(role ? { role } : {}),
    ...(email ? { email } : {}),
  };
}

function readStoredAuthUserRaw() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function readStoredAuthUser() {
  const normalized = normalizeSessionUser(readStoredAuthUserRaw());
  if (!normalized?.id && !normalized?._id) return null;
  if (!isKnownRole(normalized.role)) return null;
  return normalized;
}

export function hasValidAuthSession() {
  try {
    return Boolean(localStorage.getItem('access_token') && readStoredAuthUser());
  } catch {
    return false;
  }
}
